"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AttachmenType", {
  enumerable: true,
  get: function get() {
    return _constants.AttachmenType;
  }
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _AttachFile = _interopRequireDefault(require("@material-ui/icons/AttachFile"));

var _AttachmentIcon = _interopRequireDefault(require("../AttachmentIcon"));

var _react = _interopRequireWildcard(require("react"));

var _constants = require("../../utils/constants");

var _ = _interopRequireWildcard(require("./"));

var DEFALUT_TEXT = 'Attachment';

function AttachmentTypeIcon(props) {
  var attachmenType = props.attachmenType;

  if (attachmenType === _constants.AttachmenType.ALL) {
    return /*#__PURE__*/_react["default"].createElement(_AttachFile["default"], null);
  }

  return /*#__PURE__*/_react["default"].createElement(_AttachmentIcon["default"], {
    colored: true,
    customColor: attachmenType === _constants.AttachmenType.IMAGE ? '#FF485F' : '',
    attachmentType: _constants.attachmenTypeIconMap[attachmenType]
  });
}

function AttachmentPill(props, ref) {
  var onSelect = props.onSelect;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      selectType = _useState2[0],
      setSelectType = _useState2[1];

  var _useState3 = (0, _react.useState)(DEFALUT_TEXT),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      showText = _useState4[0],
      setShowText = _useState4[1];

  (0, _react.useImperativeHandle)(ref, function () {
    return {
      clear: function clear() {
        setSelectType([]);
        setShowText(DEFALUT_TEXT);
      }
    };
  });
  var isActive = !!selectType.filter(function (item) {
    return item !== _constants.AttachmenType.ALL;
  }).length;
  return /*#__PURE__*/_react["default"].createElement(_["default"], {
    onClick: function onClick() {
      if (!isActive) {
        onSelect([_constants.AttachmenType.HAS, _constants.AttachmenType.ALL]);
        setShowText('Has attachments');
        setSelectType([_constants.AttachmenType.HAS, _constants.AttachmenType.ALL]);
      } else {
        if (selectType.includes(_constants.AttachmenType.HAS)) {
          onSelect([]);
          setShowText(DEFALUT_TEXT);
          setSelectType([]);
        } else {
          onSelect([_constants.AttachmenType.HAS]);
          setShowText('Has attachments');
          setSelectType([_constants.AttachmenType.HAS]);
        }
      }
    },
    customLeft: true,
    isActive: isActive,
    showText: showText,
    defalutText: DEFALUT_TEXT
  }, function (_ref) {
    var handleOnToggle = _ref.handleOnToggle;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "w-64 text-dark text-lg"
    }, Object.keys(_constants.AttachmenTypeMapText).map(function (attachmenType) {
      var active = selectType.includes(attachmenType);
      return /*#__PURE__*/_react["default"].createElement(_.PillItem, {
        leftIcon: /*#__PURE__*/_react["default"].createElement(AttachmentTypeIcon, {
          attachmenType: attachmenType
        }),
        active: active,
        onClick: function onClick() {
          if (attachmenType === _constants.AttachmenType.ALL) {
            setSelectType(!active ? [attachmenType, _constants.AttachmenType.HAS] : []);
            setShowText(!active ? 'Has attachments' : DEFALUT_TEXT);
            onSelect(!active ? [_constants.AttachmenType.HAS] : []);
            handleOnToggle();
            return;
          }

          var nextSelectType = [];

          if (!active) {
            nextSelectType = [].concat((0, _toConsumableArray2["default"])(selectType), [attachmenType]).filter(function (item) {
              return item !== _constants.AttachmenType.ALL;
            });
          } else {
            nextSelectType = selectType.filter(function (item) {
              return item !== attachmenType;
            });
          }

          var filterSelectType = nextSelectType.filter(function (item) {
            return item !== _constants.AttachmenType.HAS;
          });
          var isAll = filterSelectType.length === Object.values(_constants.AttachmenTypeMapText).length - 1;

          if (isAll) {
            setSelectType([_constants.AttachmenType.HAS, _constants.AttachmenType.ALL]);
            onSelect([_constants.AttachmenType.HAS, _constants.AttachmenType.ALL]);
            setShowText('Has attachments');
            return;
          }

          setSelectType(filterSelectType);
          onSelect(filterSelectType);
          var text = _constants.AttachmenTypeMapText[filterSelectType[0]];
          var showText = (0, _.getShowText)(filterSelectType, '', {
            defalutText: DEFALUT_TEXT,
            text: text
          });
          setShowText(showText);
        },
        text: _constants.AttachmenTypeMapText[attachmenType]
      });
    }));
  });
}

var _default = /*#__PURE__*/(0, _react.forwardRef)(AttachmentPill);

exports["default"] = _default;
//# sourceMappingURL=AttachmentPill.js.map